import React, { createContext, useState, useCallback, useContext } from 'react';

const MicroFrontendContext = createContext();

export const MicroFrontendProvider = ({ children }) => {
  const [currentMfPath, setCurrentMfPath] = useState(null);

  const notifyNavigationChange = useCallback((path) => {
    setCurrentMfPath(path);
  }, []);

  return (
    <MicroFrontendContext.Provider
      value={{ currentMfPath, notifyNavigationChange }}
    >
      {children}
    </MicroFrontendContext.Provider>
  );
};

export const useMicroFrontendNavigation = () => {
  const context = useContext(MicroFrontendContext);
  if (!context) {
    throw new Error(
      'useMicroFrontendNavigation must be used within MicroFrontendProvider',
    );
  }
  return context;
};
